// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBZHZkhOUIOPyz7Xjj1Y8Y-n3QO8g-DaNU",
  authDomain: "patent-hub.firebaseapp.com",
  databaseURL: "https://patent-hub-default-rtdb.firebaseio.com",
  projectId: "patent-hub",
  storageBucket: "patent-hub.appspot.com",
  messagingSenderId: "322915781154",
  appId: "1:322915781154:web:615c4d4fc7ddcb5a49d87b",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
